<div class="userMenu_container">
  <button
    class="userMenu_button"
    aria-label="open user menu"
    aria-haspopup="true"
    (click)="toggleRightMenu()"
  >
    <app-user-avatar
      [firstName]="currentUser.userData.firstName"
      [lastName]="currentUser.userData.lastName"
      [fullName]="currentUser.userFullName"
      [avatar]="currentUser.userAvatar"
      [isAdmin]="currentUser.userRole == 2"
      [size]="'medium'"
    ></app-user-avatar>
  </button>

  @if (menuOpen()) {
    <ul
      class="userMenu_list"
      role="menu"
    >
      <li class="currentUserInfo" *blockUI="'account-menu-ui'">
        <div>
          @if (canShowMenu.editUserProfile) {
            <a [routerLink]="['/account']"
               (click)="toggleRightMenu()"
               aria-label="go to user settings"
               class="accountManagementLink currentRoleDetails"
            >
              <div class="userAvatar">
                <app-user-avatar
                  [firstName]="currentUser.userData.firstName"
                  [lastName]="currentUser.userData.lastName"
                  [fullName]="currentUser.userFullName"
                  [avatar]="currentUser.userAvatar"
                  [size]="'extralarge'"
                ></app-user-avatar>
              </div>
              <div class="userInfoIn">
                <div class="userName pageTitle">{{ currentUser.userFullName }}</div>
                <div class="userIcon">
                  @if(userIsActingAsEvaluatorForAccreditor) {
                    <mat-icon fontSet="material-icons-outlined">rate_review</mat-icon>
                  } @else if(isAdmin) {
                    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
                      <!-- Generator: Adobe Illustrator 30.0.0, SVG Export Plug-In . SVG Version: 2.1.1 Build 123)  -->
                      <path d="M10.33,19.15c-.65-.4-1.24-.9-1.78-1.5-.53-.6-.99-1.25-1.36-1.96s-.67-1.45-.88-2.24-.31-1.57-.31-2.35v-4.7l6-2.25,6,2.25v3.67c.35.05.69.13,1.03.24.33.11.66.23.97.36v-5.67l-8-3-8,3v6.1c0,2.53.75,4.84,2.26,6.91,1.51,2.08,3.42,3.4,5.74,3.99.02,0,.03,0,.04-.01,0,0,.02-.01.04-.01-.38-.38-.73-.82-1.03-1.3s-.54-.99-.72-1.52Z"/>
                      <polygon points="17.05 15.44 16.39 17.57 17.77 17.57 17.1 15.44 17.05 15.44"/>
                      <path d="M17.08,11.91c-2.77,0-5.02,2.25-5.02,5.02s2.25,5.02,5.02,5.02,5.02-2.25,5.02-5.02-2.25-5.02-5.02-5.02ZM18.51,19.93l-.4-1.26h-2.07l-.39,1.26h-1.56l2.02-6h1.93l2.02,6h-1.56Z"/>
                    </svg>
                  } @else {
                    <mat-icon fontSet="material-icons-outlined">groups</mat-icon>
                  }
                </div>
                <div class="userInfo">
                  <div class="userTitle pageHeader">
                    @if(userIsActingAsEvaluatorForAccreditor) {
                      Reviewer
                    } @else if(isFederation) {
                      Administrator
                    } @else if(isAdmin && !isAccreditor) {
                      Admin
                    } @else if(isAdmin && isAccreditor) {
                      Administrator
                    } @else if(isAccreditor) {
                      Manager
                    } @else {
                      Team Member
                    }
                  </div>
                  <div class="userOrganization pageHeader">
                    @if( userIsActingAsEvaluatorForAccreditor ) {
                      {{userOrgName=='Independent Reviewers'?'':userOrgName}}
                    } @else if ( isAccreditor ) {
                      {{currentAccount.accountName}}
                    } @else {
                      {{currentAccount.accountName}}
                    }
                  </div>
                </div>
              </div>


            </a>
          }
        </div>
      </li>
      @if(canManageUsers()){
        <li routerLinkActive="active" class="teamManagementExpansionPanel">
          <mat-expansion-panel  class="mat-elevation-z0" [expanded]="expansionPanelOpen()">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon fontSet="material-icons-outlined">group_add</mat-icon>
                <span class="pageHeader">Team ({{ totalMembers()}})</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <app-team-management
                [(totalMembersCount)]="totalMembers"
              ></app-team-management>
            </ng-template>
          </mat-expansion-panel>
        </li>
      }


      <!-- @if (canShowMenu.settings) { &lt;!&ndash; always false for now &ndash;&gt;
        <li routerLinkActive="active" class="withPadding">
          <a routerLink="/settings/overview" (click)="toggleRightMenu()">
            <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
            <span class="pageHeader">Settings</span>
          </a>
        </li>
      } -->
      <!-- //this is for Stacey Rowand from CAHME -->
      @if (canShowMenu.manageStandardsAsAccreditor) {
        <li routerLinkActive="active" class="withPadding">
          <a routerLink="/accreditation/manage-standards" (click)="toggleRightMenu();">
            <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
            <span class="pageHeader">Manage Standards</span>
          </a>
        </li>
      }
      <!-- //this is for Stacey Rowand from CAHME -->
      @if (canShowMenu.manageProgramTemplatesAsAccreditor) {
        <li routerLinkActive="active" class="withPadding">
          <a routerLink="/admin-tools/program-template/select-program-details-step" (click)="toggleRightMenu();">
            <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
            <span class="pageHeader">Manage Templates</span>
          </a>
        </li>
      }

      <li routerLinkActive="active">
        <mat-expansion-panel class="mat-elevation-z0 accountsList"  [expanded]="accountsPanelOpen()">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon fontSet="material-icons-outlined">switch_accounts</mat-icon>
              <span class="pageHeader">Accounts</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-accounts-list
          ></app-accounts-list>
        </mat-expansion-panel>
      </li>

      @if(canManageAccount()){
        <li class="withPadding">
          <a (click)="manageAccount()">
            <mat-icon fontSet="material-icons-outlined">manage_accounts</mat-icon>
            <span class="pageHeader">Manage Account</span>
          </a>
        </li>
      }

      @if (isImpersonatedUser) {
        <li class="withPadding">
          <a (click)="stopImpersonate(); toggleRightMenu()">
            <mat-icon fontSet="material-icons-outlined">person_off</mat-icon>
            <span class="pageHeader">Restore Account</span>
          </a>
        </li>
      }

      <!--
      <li class="lightModeSelector">
        <app-weave-radio-group
          [label]="'VIEW'"
          [radioList]="lightOptions"
          [data]="lightMode"
          [showOptionsVertical]="true"
          (changed)="changeLightMode($event)"
        ></app-weave-radio-group>
      </li>
      -->
      <li class="withPadding">
        <a (click)="toggleRightMenu(); logout()">
          <mat-icon>logout</mat-icon>
          <span class="pageHeader">Sign Out</span>
        </a>
      </li>
    </ul>
  }
</div>
